import { forwardRef } from 'react';
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { CloseIcon, SearchIcon } from '~/icons';
import { searchTextFieldStyles } from './styles';

const SearchTextField = forwardRef<HTMLInputElement, TextFieldProps & { onClear?: () => void }>((props, ref) => {
  const { slotProps, sx, value, onClear, ...rest } = props;

  return (
    <TextField
      fullWidth={false}
      sx={{ ...searchTextFieldStyles, ...sx }}
      slotProps={{
        ...slotProps,
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton size="small" onClick={onClear}>
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          ) : null,

          ...slotProps?.input,
        },
      }}
      placeholder="Search"
      value={value}
      {...rest}
      ref={ref}
    />
  );
});

export default SearchTextField;
